let backtop = {
    init() {

        $('.backtop').click(function(){
            var page = $(this).attr('href');
            $('html, body').animate( { scrollTop: $(page).offset().top }, 500 );
        })


        $(window).scroll(function() {

        if ($(this).scrollTop() > 300) {
            $('.backtop').addClass('active');

          } else {
            $('.backtop').removeClass('active');
          }

        });

    }
}

export default backtop;
